import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getCaseInfo } from './index';

export const startArbitrator = () => {
    return({
        type: actionTypes.ARBITRATOR_START,
    });
}

export const failArbitrator = (error) => {
    return({
        type: actionTypes.ARBITRATOR_FAIL,
        error: error,
    });
}

export const successArbitrator = (payload) => {
    return({
        type: actionTypes.ARBITRATOR_SUCCESS,
        payload: payload,
    });
}

export const startSetArbitrator = () => {
    return({
        type: actionTypes.SET_ARBITRATOR_START,
    });
}

export const failSetArbitrator = (error) => {
    return({
        type: actionTypes.SET_ARBITRATOR_FAIL,
        error: error,
    });
}

export const successSetArbitrator = (payload) => {
    return({
        type: actionTypes.SET_ARBITRATOR_SUCCESS,
        payload: payload,
    });
}

export const onBoardingStepCompleteStart = () => {
    return({
        type: actionTypes.ONBOARDING_STEP_COMPLETE_START,
    });
}

export const onBoardingStepCompleteSuccess = (payload) => {
    return({
        type: actionTypes.ONBOARDING_STEP_COMPLETE_SUCCESS,
        payload: payload,
    });
}

export const onBoardingStepCompleteFail = (error) => {
    return({
        type: actionTypes.ONBOARDING_STEP_COMPLETE_FAIL,
        error: error,
    });
}
export const startDeliverAward = () => {
    return({
        type: actionTypes.START_DELIVER_AWARD,
    });
}

export const failDeliverAward = (error) => {
    return({
        type: actionTypes.FAIL_DELIVER_AWARD,
        error: error,
    });
}

export const successDeliverAward = () => {
    return({
        type: actionTypes.SUCCESS_DELIVER_AWARD,
    });
}

export const startUploadSignature = () => {
    return({
        type: actionTypes.START_UPLOAD_SIGNATURE,
    });
}

export const failUploadSignature = (error) => {
    return({
        type: actionTypes.FAIL_UPLOAD_SIGNATURE,
        error: error,
    });
}

export const successUploadSignature = () => {
    return({
        type: actionTypes.SUCCESS_UPLOAD_SIGNATURE,
    });
}

export const startUserInformation = () => {
    return({
        type: actionTypes.START_USER_INFORMATION,
    });
}

export const failUserInformation= (error) => {
    return({
        type: actionTypes.FAIL_USER_INFORMATION,
        error: error,
    });
}

export const successUserInformation = (payload) => {
    // console.log('successUserInformation payload: '+JSON.stringify(payload))
    return({
        type: actionTypes.SUCCESS_USER_INFORMATION,
        payload: payload,
    });
}

export const arbitrators = () => {
    // console.log('get arbitrators list ');
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getArbitratorList`;
    return (dispatch) => {
        dispatch(startArbitrator());
        axios.post(url)
        .then((response) => {
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            // console.log('*get arbitrators*: '+JSON.parse(response.data).arbitrators);
            const arbitratorList = JSON.parse(response.data).arbitrators.filter(a => a.lastname !== 'Faisal');
            dispatch(successArbitrator(arbitratorList));
        })
        .catch((error) => {
            console.log(error);
            dispatch(failArbitrator(error));
        });
    };
}

export const arbitratorsChi = () => {
    // console.log('get arbitrators list ');
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getArbitratorListChi`;
    return (dispatch) => {
        dispatch(startArbitrator());
        axios.post(url)
        .then((response) => {
            console.log('get arbitrators*: '+response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            const arbitratorList = JSON.parse(response.data).arbitrators.filter(a => a.lastname !== 'Faisal');
            dispatch(successArbitrator(arbitratorList));

        })
        .catch((error) => {
            console.log(error);
            dispatch(failArbitrator(error));
        });
    };
}

export const setArbitrators = (caseId, firstTime=false, arbitratorId, userType, handleComplete) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/addClaimantArbitrator`;
    let payload = {
        arbitratorId: arbitratorId,
        caseId: caseId,
        userType: userType,
        isFirstTime: firstTime
    }
    console.log('setArbitrators payload: '+JSON.stringify(payload))
    return (dispatch) => {
        dispatch(startSetArbitrator());
        axios.post(url, payload)
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                // throw (`login ${response.data}`);
                dispatch(failSetArbitrator('error'));
            }
            dispatch(successSetArbitrator(response.data));
            handleComplete();

        })
        .catch((error) => {
            console.log(error);
            dispatch(failSetArbitrator(error));
        });
    };
}

export const setArbitratorsAdmin = (caseId, arbitratorId, handleComplete) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/addClaimantArbitrator`;
    let payload = {
        arbitratorId: arbitratorId,
        caseId: caseId,
        userType: 'admin'
    }
    return (dispatch) => {
        dispatch(startSetArbitrator());
        axios.post(url, payload)
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                // throw (`login ${response.data}`);
                dispatch(failSetArbitrator('error'));
            }
            dispatch(successSetArbitrator(response.data));
            
            handleComplete();
            

        })
        .catch((error) => {
            console.log(error);
            dispatch(failSetArbitrator(error));
        });
    };
}

export const onBoardingStepCompletion = (uniqueId, caseId, userType, step_completed) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/steps_completed`;
    return (dispatch) => {
        dispatch(onBoardingStepCompleteStart());
        const payload= {
            uniqueId: uniqueId,
            caseId: caseId,
            userType: userType,
            step_completed: step_completed,
        }
        axios.post(url, payload)
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                // throw (`login ${response.data}`);
                dispatch(onBoardingStepCompleteFail('error'));
            }
            console.log(`onBoardingStepCompletion ${JSON.stringify(response.data)}`)
            dispatch(onBoardingStepCompleteSuccess(response.data));
            dispatch(getCaseInfo(caseId, uniqueId));

        })
        .catch((error) => {
            console.log(error);
            dispatch(onBoardingStepCompleteFail(error));
        });
    };
}

export const uploadSignature = (caseId, file_name, userType, name, base_data, useDefault = false, setDefault = false) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/signature_uploads`;
    let payload = {
        file_name: file_name,
        caseId: caseId,
        name: name,
        userType: userType,
        base_data: base_data,
    }
    if (setDefault){
        payload.setAsDefault = true
    }
    console.log('setDefault: '+setDefault)
    console.log('useDafault: '+useDefault)
    if (useDefault){
        payload.useDefault = true
    }
    return (dispatch) => {
        dispatch(startUploadSignature());
        axios.post(url, payload, { timeout: 120000 })
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`/signature_uploads ${response.data}`);
            }
            dispatch(successUploadSignature());
            //handleComplete();

        })
        .catch((error) => {
            console.log('upload Signature error: '+error)
            console.log(error);
            dispatch(failUploadSignature(error));
        });
    };
}

export const deliverAward = (caseId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/deliverAward`;
    let payload = {
        caseId: caseId,
    }
    return (dispatch) => {
        dispatch(startDeliverAward());
        axios.post(url, payload)
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            dispatch(successDeliverAward());
            window.location.reload()

        })
        .catch((error) => {
            console.log(error);
            dispatch(failDeliverAward(error));
        });
    };
}

export const getUserInformation = (uniqueId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getUserInfo`;
    const payload= {
        uniqueId: uniqueId,
    }
    return (dispatch) => {
        dispatch(startUserInformation());
        axios.post(url, payload)
        .then((response) => {
            // console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            console.log('getUserInformation response: '+JSON.stringify(response))
            dispatch(successUserInformation(response.data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(failUserInformation(error));
        });
    }
}